import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kilobytes',
  standalone: true,
})
export class KilobytesPipe extends DecimalPipe implements PipeTransform {
  public override transform(value: number, digitsInfo?: string, locale?: string): string | null;
  public override transform(value: null | undefined, digitsInfo?: string, locale?: string): null;
  public override transform(value: number | null | undefined, digitsInfo = '1.0-2', locale?: string): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const kilobytes = value / 1024;
    const formattedValue = super.transform(kilobytes, digitsInfo, locale);

    return formattedValue ? `${formattedValue} KB` : null;
  }
}
